<template>
  <v-dialog v-model="dialog" width="1000">
    <v-card>
        <v-card-title>Import policies (csv)</v-card-title>
        <v-card-text>
            <p>The CSV should contain the following headers: {{ requiredFields.join(', ') }}.</p>
            <v-textarea
                @input="checkCSV"
                v-model="dataset"
                outlined
                placeholder="Paste CSV here"
            ></v-textarea>
            <v-alert type="error" v-if="!valid">
              Invalid format. Please check the CSV and try again.
              {{ error }}
            </v-alert>
            <v-alert type="success" v-if="valid && dataset.length > 0">Data is valid</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="cancel()" outlined>Cancel</v-btn>
          <v-btn color="primary" :disabled="!valid" @click="save()" :loading="saving">
            Import
          </v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const csv = require('csvtojson');

export default {
  name: 'PolicyImportModal',
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  watch: {
    dialog(newVal, oldVal) {
      console.log('Prop changed: ', newVal, ' | was: ', oldVal);
      this.showDialog = newVal;
    },
  },
  data() {
    return {
      showDialog: false,
      dataset: 'elyCenter;iscoClass;primaryLabel;startDate;endDate;labelFi;labelEn;labelSv;areas',
      valid: true,
      saving: false,
      error: '',
      requiredFields: ['elyCenter', 'startDate', 'endDate', 'iscoClass', 'primaryLabel', 'labelFi', 'labelEn', 'labelSv', 'areas'],
    };
  },
  methods: {
    checkCSV() {
      csv({
        delimiter: 'auto',
        trim: true,
      })
        .fromString(this.dataset)
        .then((json) => {
          console.log(json);
          const keys = json.length > 0 ? Object.keys(json[0]) : [];
          console.log(keys);
          for (const field of this.requiredFields) {
            if (!keys.includes(field)) {
              this.valid = false;
              return;
            }
          }
          this.valid = true;
        })
        .catch((err) => {
          this.valid = false;
          this.error = err;
        });
    },
    save() {
      this.saving = true;
      csv({
        delimiter: 'auto',
        trim: true,
      })
        .fromString(this.dataset)
        .then(async (policies) => {
          const mutatedPolicies = policies.map((policy) => {
            const mutatedPolicy = {
              elyCenter: policy.elyCenter,
              startDate: policy.startDate,
              endDate: policy.endDate,
              iscoClass: policy.iscoClass,
              primaryLabel: policy.primaryLabel,
              labelFi: policy.labelFi,
              labelEn: policy.labelEn,
              labelSv: policy.labelSv,
              areas: policy.areas,
            };
            mutatedPolicy.areas = policy.areas.split(',');
            // Get areas from store
            mutatedPolicy.areas = mutatedPolicy.areas.map((area) => {
              const areaObject = this.$store.state.mapData.find(mapArea => mapArea.id === area);
              return {
                id: areaObject.id,
                name: areaObject.name,
              };
            });
            mutatedPolicy.startDate = new Date(policy.startDate).toISOString();
            // Check for end date, if not defined set to 6 months from start date
            if (policy.endDate.length === 0 || !policy.endDate) {
              const endDate = new Date(policy.startDate);
              endDate.setMonth(endDate.getMonth() + 6);
              mutatedPolicy.endDate = endDate.toISOString();
            } else {
              mutatedPolicy.endDate = new Date(policy.endDate).toISOString();
            }
            mutatedPolicy.label = policy.primaryLabel;
            mutatedPolicy.labelTranslations = {
              fi: policy.labelFi,
              en: policy.labelEn,
              sv: policy.labelSv,
            };
            delete mutatedPolicy.primaryLabel;
            delete mutatedPolicy.labelFi;
            delete mutatedPolicy.labelEn;
            delete mutatedPolicy.labelSv;
            // Clean up iscoClass to only contain numbers
            mutatedPolicy.iscoClass = mutatedPolicy.iscoClass.replace(/[^0-9]/g, '');
            console.log('Mutated policy', mutatedPolicy);
            return mutatedPolicy;
          });
          try {
            // Check for duplicates in store and filter them out
            const existingPolicies = this.$store.state.policies;
            const filteredPolicies = mutatedPolicies.filter((policy) => {
              return !existingPolicies.some(existingPolicy => (
                existingPolicy.iscoClass === policy.iscoClass
                && existingPolicy.startDate === policy.startDate
                && existingPolicy.endDate === policy.endDate
                && existingPolicy.elyCenter === policy.elyCenter));
            });
            if (filteredPolicies.length === 0) {
              this.saving = false;
              this.$emit('saved');
              return;
            }
            await this.$store.dispatch('dispatchPostPolicies', { policies: filteredPolicies });
            this.saving = false;
            this.$emit('saved');
          } catch (error) {
            this.saving = false;
            console.log(error);
          }
        })
        .catch(() => {
          this.saving = false;
          this.valid = false;
        });
    },
    cancel() {
      this.saving = false;
      this.dataset = '';
      this.$emit('cancel');
    },
  },
};
</script>

<style>

</style>
